/* @format */
import EventBus from '@/scripts/event-bus';

export const APPOINTMENT_REQUEST_WIDGET_NAME = 'appointment-request-widget';

export const APPOINTMENT_REQUEST_TIME_FORMAT = 'HH:mm';

export function openAppointmentRequestWidget(config) {
    EventBus.$emit('open-widget', {
        name: APPOINTMENT_REQUEST_WIDGET_NAME,
        paymentMethods: config?.paymentMethods ?? [],
    });
}
